import * as React from 'react';
import classnames from 'classnames';

import { useFirebase } from '@src/hooks/useFirebase';
import { useFormInput } from '@src/hooks/useFormInput';
import { useFormValidation } from '@src/hooks/useFormValidation';
import { HaldiButton } from '@src/routes/common/components/HaldiButton';
import { AppLink } from '@src/services/app/components/AppLink';
export interface FormForgotPasswordProps {
  className?: string;
}

/**
 * @name FormForgotPassword
 * @description Basic form for login which makes use of basic HTML validation
 */
export const FormForgotPassword = (props: FormForgotPasswordProps) => {
  const { className } = props;

  // Hooks
  const formRef = React.useRef<HTMLFormElement>(null);
  const inputEmail = useFormInput('');
  const { resetPassword } = useFirebase();
  const isValid = useFormValidation(formRef, [inputEmail.value]);

  // Styles
  const cssBtn = classnames('w-[250px]', { disabled: !isValid });
  const cssComponent = classnames('mx-auto text-center', className);

  // Handlers
  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const email = inputEmail.value.toLowerCase();

    try {
      resetPassword(email);
    } catch (err) {
      // console.log(` 💬 ~ asdf`, err);
    }
  };

  return (
    <form
      className={cssComponent}
      onSubmit={onSubmit}
      ref={formRef}
      style={{ maxWidth: 320 }}
    >
      {/* <AppErrorMessage className="text-red mb-2x" message={errorMessage} /> */}

      <label className="sr-only" htmlFor="email">
        Email
      </label>
      <input
        autoComplete="email"
        className="mb-3x"
        id="email"
        onChange={inputEmail.onChange}
        placeholder="Email"
        required
        type="email"
        value={inputEmail.value}
      />
      <HaldiButton className={cssBtn} type="submit">
        Reset Password
      </HaldiButton>
      <div className="mt-3x block text-16">
        <AppLink className="font-semibold text-gray-5" href="/login">
          Back to login
        </AppLink>
      </div>
    </form>
  );
};
